import { OILSTEEL_COLORS } from '../oilsteelThemeConf';
export const oilsteelSentryReportStyle = {
    '.sentry-error-embed-wrapper .form-submit button[type="submit"]': {
        backgroundColor: `${OILSTEEL_COLORS.success.main} !important`,
        border: 'none !important',
        outline: 'none !important',
    },
    '.sentry-error-embed-wrapper .form-submit button[type="submit"]:hover': {
        backgroundColor: `${OILSTEEL_COLORS.success.dark} !important`,
    },
    '.sentry-error-embed-wrapper .form-submit button[type="submit"]:active': {
        backgroundColor: `${OILSTEEL_COLORS.success.main} !important`,
    },
};
//# sourceMappingURL=oilsteelSentryReportStyle.js.map